import React from "react";
import AButton from "../../../../../views/pages/manage/common/form-fields-mui/AButton";
import { getFormattedAmount } from "../../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

const BulkActionBar = ({
  count,
  totalAmount,
  onProceed,
  depositForm,
  onViewDeposit,
  onSendForApproval ,
  isApiCalling
}) => {
  const style = count === 0 ? { background: "#757575" } : {};
  return (
    <div className="cm-bulk-bar" style={style}>
      <div className="cm-bulk-info">
        {count === 0
          ? "Select receipts to deposit"
          : `${count} Receipts • ${getFormattedAmount(totalAmount)}`}
      </div>
      <div>
        {depositForm?.depositSlipNo && (
          <AButton
            disabled={count === 0}
            variant="general"
            className="btn btn-primary"
            onClick={onViewDeposit}
            updatedStyle={{ color: "#0F0F0F" }}
          >
            View deposit slip
          </AButton>
        )}

        {depositForm?.depositSlipNo ? (
          <AButton
            disabled={count === 0 || isApiCalling}
            variant="primary_filled"
            className="btn btn-primary"
            onClick={onSendForApproval}
          >
            Send for approval
          </AButton>
        ) : (
          <AButton
            disabled={count === 0}
            variant="primary_filled"
            className="btn btn-primary"
            onClick={onProceed}
          >
            Upload Deposit slip
          </AButton>
        )}
      </div>
    </div>
  );
};

export default BulkActionBar;
